import './App.css';
import NutritionalInfo from './nutritional-info';
import SubMenu from './sub-menu';
import SpecialsItem from './specials-item';
import SimpleSlider from './simple-slider';
import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import TweenMax from 'gsap';


let imagePaths = [];
let imageNames = [];

export default class App extends React.Component {

  constructor(props) {
    super(props);
    let hashId = window.location.hash.substring(0, window.location.hash.length);
    let self = this;

    this.state = {
      categories: [],
      menus: [],
      nutritionalInfo: {},
      isNutritionalInfoSelected: false,
      displayData: [],
      isMobile: false,
      main: 'active' ,
      kids: '' ,
      sushi: '',
      drinks: '',
      lastHash:hashId,
      currentIndex: 0,
      lastScrollY: 0,
      initLoad: false,
      selectedMenus: []
    }
  }

  componentWillUnmount() {
      window.removeEventListener("hashchange", this.onHashChange.bind(this), false);
  }

  loadImages(names, files, onAllLoaded) {
      var i = 0, numLoading = names.length;
      const onload = () => --numLoading === 0 && onAllLoaded();
      const images = {};
      while (i < names.length) {
          const img = images[names[i]] = new Image;
          img.src = files[i++];
          img.onload = onload;
      }
      return images;
  }

  initialLoad () {
    let self = this;


    setTimeout(()=>{

      window.resizeAllMasonryItems1();
      this.onHashChange()

      if (this.state.isMobile) {
        if ($('.menu_header_images_slider')[0]) {
          TweenMax.to('.menu_header_images_slider', {stagger:0.2, alpha:1});
        }
      }
      else {
        if ($('.special')[0]) {
          TweenMax.to('.special', {stagger:0.2, alpha:1});
        }

      }

      TweenMax.to('.masonry-sub-menu', {stagger:0.2, alpha:1});
    },300);
    console.log('init load')
  }

  componentDidMount() {
    let self = this;
    window.addEventListener('resize', this.onResize.bind(this))
    window.addEventListener("hashchange", this.onHashChange.bind(this), false);
    const host = window.location.protocol + "//" + window.location.host;

    //$.ajax({url: "https://testsite.ninjatestbox.com/wp-json/api/ocean_basket_menu_items", success: function(result){
    $.ajax({url: host + "/wp-json/api/ocean_basket_menu_items", success: function(result){
      self.setState({categories: result.categories, menu: result.menu, initLoad: true});
      console.log(result)
      if (window.innerWidth < 1024) {
        if ($('.menu_header_images_slider')[0]) {
          TweenMax.set('.menu_header_images_slider', { alpha:0});
        }
      }
      else {
        if ($('.special')[0]) {
          TweenMax.set('.special', {alpha:0});
        }
      }

      TweenMax.set('.masonry-sub-menu', {alpha:0});

      for (var i = 0; i < result.categories.length; i ++) {
        for (var j = 0; j < result.categories[i].sub_categories.length; j++) {
          if (result.categories[i].sub_categories[j].image) {
            imageNames.push('img'+j);
            imagePaths.push(result.categories[i].sub_categories[j].image);
          }
        }
      }

      self.loadImages(imageNames, imagePaths, self.initialLoad.bind(self));

    }});
    this.onResize();
    window.history.pushState(null, null, this.state.lastHash);

    this.specialsRef = React.createRef();
    this.menusRef = React.createRef();
    this.nutritionalInfoRef = React.createRef();
    this.menuItemClicked = false

  }

  onResize () {
    if (window.innerWidth >= 1024) {
      this.setState({isMobile: false})

    }
    else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      this.setState({isMobile: true});

    }
    else {
      this.setState({isMobile: true})
    }
    window.resizeAllMasonryItems1();
  }

  getCurrentIndex (hash) {
    switch (hash) {
      case 'main':
        return 0;
      case 'sushi':
        return 1;
      case 'kids':
        return 2;
      case 'drinks':
        return 3;

    }
  }

  onHashChange () {
    let hashId = (window.location.hash.substring(1, window.location.hash.length)).split("/")
    let info = this.getNutritionalValues(hashId[1]);
    let self = this;

    // show nutritional info
    if (info && info.nutritionalInfo.length > 0) {
        self.setState({isNutritionalInfoSelected: true, nutritionalInfo: info, lastScrollY: window.scrollY});

    }
    else {
      if (hashId[0] === "main" || hashId[0] === "sushi" || hashId[0] === "kids" || hashId[0] === "drinks" || hashId[0] === "") {

        if (self.menuItemClicked) {

          //return;
        }

        if (hashId[0] === "") {
          hashId[0] = "main";
          window.history.pushState(null, null,'#main');
            self.setState({lastHash: '#'+hashId[0]})
        }

          self.setState({
            isNutritionalInfoSelected: false,
            currentIndex: this.getCurrentIndex(hashId[0]),
            main: '' ,
            kids: '' ,
            sushi: '',
            drinks: '',
            lastHash: '#'+hashId[0],
            [hashId[0]]: 'active'});

      }
    }

  }

  getNutritionalValues (hashId) {
    for (var i = 0; i < this.state.menu.length; i++) {
        if (hashId === this.state.menu[i].slug) {
          return this.state.menu[i]
        }
    }
    return "";
  }

  onMenuItemClick (e) {
    e.preventDefault();
    let itemClicked = $(e.target).parent().attr('id');

    if (!itemClicked) {
      return;
    }
    let currentIndex = $(e.target).parent().data('index');
    let lastHash = $(e.target).parent().data('slug');
    let self = this;
    this.menuItemClicked = true;

      self.setState({
        currentIndex: currentIndex,
        main: '' ,
        kids: '' ,
        sushi: '',
        drinks: '',
        lastHash: lastHash,
        [itemClicked]: 'active'
      });

      window.history.pushState(null, null,lastHash);


      //self.setState({lastScrollY: window.scrollY});

      self.menuItemClicked = false;

  }

  updateSubMenu (subMenuId, isSelected) {
    let selectedMenus = this.state.selectedMenus;
    if (isSelected) {
      selectedMenus.push(subMenuId)
    }
    else {
      let index = selectedMenus.indexOf(subMenuId);
      selectedMenus.splice(index,1);
    }

    this.setState({selectedMenus: selectedMenus})
    //console.log(this.state.selectedMenus)
  }

  componentDidUpdate(prevProps, prevState) {
    //returning from nutrional info
    if (prevState.isNutritionalInfoSelected !== this.state.isNutritionalInfoSelected) {
      if (!this.state.isNutritionalInfoSelected) {
        TweenMax.set('.masonry-sub-menu', {y:0,alpha:0});
          if (this.state.isMobile) {
            if ($('.menu_header_images_slider')[0]) {
            TweenMax.set('.menu_header_images_slider', {alpha:0});
          }
          }
          else {
            if ($('.special')[0]) {
              TweenMax.set('.special', {alpha:0});
            }

          }
         //TweenMax.set('.masonry-container', {alpha:0});
         window.resizeAllMasonryItems1();


          setTimeout(()=>{
            window.resizeAllMasonryItems1();
            let self = this;
           TweenMax.to('.masonry-sub-menu', {delay:0.3, y:0, alpha:1, onComplete:()=>{
             //window.scrollTo(0,self.state.lastScrollY - 20);
             $("html, body").animate({ scrollTop: self.state.lastScrollY }, 300);


           }});
            if (this.state.isMobile) {
              if ($('.menu_header_images_slider')[0]) {
                TweenMax.to('.menu_header_images_slider', .3, {alpha:1});
              }
            }
            else {
              if ($('.special')[0]) {
                TweenMax.to('.special', {alpha:1});
              }
            }

          },100);

          // setTimeout(()=>{
          //   TweenMax.to('.masonry-container', .1, {alpha:1});
          //
          //
          // },200)
      }
    }
    //changing menus
    if (prevState.currentIndex !== this.state.currentIndex) {
      //console.log('state', this.state.currentIndex)
      $('.masonry-container').css('height', '1000px');
      //$('.menu_page_header').css('height', '1054px')

      TweenMax.set('.masonry-sub-menu', {y: 20, alpha:0});
      if (this.state.isMobile) {
        if ($('.menu_header_images_slider')[0]) {
          TweenMax.set('.menu_header_images_slider', {alpha:0});
        }
      }
      else {
        if ($('.special')[0]) {
          TweenMax.set('.special', {alpha:0});
        }
      }
      // if (this.state.categories[this.state.currentIndex].specials.length === 0) {
      //    //window.scrollTo(0,0);
      //    window.scrollTo(0,this.state.lastScrollY);
      //
      // }
      // else {
      //   window.scrollTo(0,this.state.lastScrollY);
      //
      // }
      window.resizeAllMasonryItems1();

        setTimeout(()=>{
          window.resizeAllMasonryItems1();

          $('.masonry-container').css('height', 'auto');
          //$('.menu_page_header').css('height', 'auto')

         TweenMax.to('.masonry-sub-menu', {delay:0.5, y: 0, stagger:.1, alpha:1});
         if (this.state.isMobile) {
            if ($('.menu_header_images_slider')[0]) {
             TweenMax.to('.menu_header_images_slider', .3, {alpha:1});
           }
         }
         else {
           if ($('.special')[0]) {
             TweenMax.to('.special', {stagger:.1, alpha:1});
           }
         }


       },100)
    }
  }


  update (isNutritionalInfoSelected, ref) {
    let self = this;
    self.menuItemClicked = true;
    let hashId = (window.location.hash.substring(1, window.location.hash.length)).split("/")

    self.setState({
      isNutritionalInfoSelected: isNutritionalInfoSelected,
      lastHash: "#" + hashId[0]
    });

    self.menuItemClicked = false;

  }

  render() {

    let specials = "";
    if (this.state.categories.length > 0) {
      if (!this.state.isMobile) {
        specials = this.state.categories[this.state.currentIndex].specials.map((specialsItem, index)=>{
          return (  <SpecialsItem key={specialsItem.title} data={specialsItem} />)
        })
      }
      else {
        specials = (  <SimpleSlider data={this.state.categories[this.state.currentIndex].specials} />)
      }
    }

    let display = "";

      display = (!this.state.isNutritionalInfoSelected ?
        <div>
        <section className="menu_page_header" style={{display: + this.state.categories.length > 0 && this.state.categories[this.state.currentIndex].specials.length > 0 ? 'block': 'none' }}>

        	<div className="container">
        		<h6>Menu</h6>
        		<h2>our special meals</h2>
        	</div>
        	<div className="container menu_header_images_slider">
        		<div ref={this.specialsRef} className="menu_specials">
              {specials}
          	</div>
          </div>

        </section>

        <section className="menu_main_wrapper">
          <section className="menu_navigation">
            <div className="container">

              <ul>

                {this.state.categories.length > 0 ?
                this.state.categories.map((menuItem, menuItemIndex)=>{
                  return(<li key={menuItem.id} onClick={this.onMenuItemClick.bind(this)} data-slug={"#"+menuItem.slug} data-index={menuItemIndex} id={menuItem.slug} className={this.state[menuItem.slug] + " hover-underline-animation"}><a href={"#" + menuItem.slug}>{menuItem.name}</a></li>)
                }): "" }

              </ul>

          </div>
          </section>
          <div className="menu_main_body" ref={this.menusRef }>
            <div className="container">
              <div className="masonry-container">
            {this.state.categories.length > 0 ?

              this.state.categories[this.state.currentIndex].sub_categories.map((menuItem)=>{

                return (
                  <SubMenu key={menuItem.id} data={menuItem} selectedMenus={this.state.selectedMenus} updateSubMenu={this.updateSubMenu.bind(this)} lastHash ={this.state.lastHash} />
                )
              })

          : ""
          }
          </div>
          </div>
          </div>

        </section>
        </div>:
        <div>
          <NutritionalInfo data={this.state.nutritionalInfo} lastHash={this.state.lastHash} update={this.update.bind(this)}/>
        </div>)

    return (
    <div>
    {display}
    </div>
    );
  }
}

window.decodeHtml = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}


window.resizeMasonryItem1 = function (item){
 /* Get the grid object, its row-gap, and the size of its implicit rows */
 var grid = document.getElementsByClassName('masonry-container')[0],
     rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
     rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

 /*
  * Spanning for any brick = S
  * Grid's row-gap = G
  * Size of grid's implicitly create row-track = R
  * Height of item content = H
  * Net height of the item = H1 = H + G
  * Net height of the implicit row-track = T = G + R
  * S = H1 / T
  */
 var itemH = item.querySelector('.masonry-content').getBoundingClientRect().height;
 var rowSpan = Math.ceil((itemH+rowGap)/(rowHeight+rowGap));

 /* Set the spanning as calculated above (S) */
 item.style.gridRowEnd = 'span '+rowSpan;

 /* Make the images take all the available space in the cell/item */
 // item.querySelector('.masonry-content').style.height = rowSpan * 10 + "px";
 //console.log('rowSpan', rowSpan)
}

/**
* Apply spanning to all the masonry items
*
* Loop through all the items and apply the spanning to them using
* `resizeMasonryItem()` function.
*
* @uses resizeMasonryItem
*/
window.resizeAllMasonryItems1 = function (){
 // Get all item class objects in one list
 var allItems = document.getElementsByClassName('masonry-sub-menu');

 /*
  * Loop through the above list and execute the spanning function to
  * each list-item (i.e. each masonry item)
  */
 for(var a=0;a<allItems.length;a++){
   window.resizeMasonryItem1(allItems[a]);
 }
}
